import { HyperSpaceBarChart } from './widgets/HyperSpaceBarChart';
import { HyperSpaceColumnChart } from './widgets/HyperSpaceColumnChart';
import { HyperSpaceLineChart } from './widgets/HyperSpaceLineChart';
import { HyperSpacePieChart } from './widgets/HyperSpacePieChart';
import { TemplateHyperSpaceBarChart } from './templates/TemplateHyperSpaceBarChart';
import { TemplateHyperSpaceColumnChart } from './templates/TemplateHyperSpaceColumnChart';
import { TemplateHyperSpaceLineChart } from './templates/TemplateHyperSpaceLineChart';
import { TemplateHyperSpacePieChart } from './templates/TemplateHyperSpacePieChartWidget';

export const hyperSpaceWidgets = {
    panels: {},
    widgets: {
        analytics: [
            HyperSpaceBarChart,
            HyperSpaceColumnChart,
            HyperSpaceLineChart,
            HyperSpacePieChart,
        ],
    },
};

export const hyperSpaceTemplates = {
    panels: {},
    templates: {
        analytics: [
            TemplateHyperSpaceBarChart,
            TemplateHyperSpaceColumnChart,
            TemplateHyperSpaceLineChart,
            TemplateHyperSpacePieChart,
        ],
    },
};
